@use "styles/variables" as *;

.layoutHeader {
  // default size
  width: 100%;
  height: var(--layout-header);
  background-color: transparent;
  padding: 0;
  margin: 0 auto;

  // default positioning - duplicate
  position: absolute;
  top: 0;
  z-index: var(--z-index-header);

  &.floating {
    max-width: unset;
    background-color: transparent;
  }

  &.fixed {
    background-color: transparent;
    max-width: unset;
  }

  &.normal {
    max-width: var(--max-width);
    background-color: transparent;

    @media only screen and (min-width: $max-width) {
      border-radius: 0 0 var(--layout-sheet-radius) var(--layout-sheet-radius);
    }
  }

  .innerDiv {
    max-width: var(--max-width);
    margin: auto;
    height: var(--layout-header);

    // items alignment
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding-top: var(--layout-padding);
    padding-bottom: var(--layout-padding);
    // padding right is 5px due to back button padding
    // minus the back button padding
    padding-right: calc(var(--layout-padding) - 8px);
    padding-left: calc(var(--layout-padding) - 8px);

    // inside divisioning for spacing between items
    > div {
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .headerStart {
      h1 {
        margin-right: 5px;
        color: #000;
        text-align: right;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .scrollDivider {
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 0;
    padding: 0;
    height: 0;
    line-height: 0;
  }
}
